module.exports = __webpack_public_path__ + "img/icon_survey.6db7f468.svg";